import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow-lg rounded-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Πολιτική Απορρήτου – Weekly Talks</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-6">
              <strong>Τελευταία ενημέρωση:</strong> {new Date().toLocaleDateString('el-GR')}
            </p>

            <p className="text-gray-700 mb-8 text-lg">
              Η εφαρμογή Weekly Talks σέβεται και προστατεύει τα προσωπικά σας δεδομένα. Η παρούσα Πολιτική Απορρήτου εξηγεί πώς συλλέγουμε, χρησιμοποιούμε και προστατεύουμε τις πληροφορίες σας.
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Συλλογή Δεδομένων</h2>
              <p className="text-gray-700 mb-4">
                Η εφαρμογή δεν συλλέγει προσωπικά δεδομένα χωρίς τη συγκατάθεσή σας.
              </p>
              <p className="text-gray-700 mb-4">
                Ενδέχεται να συλλέγουμε ορισμένες βασικές πληροφορίες, όπως:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Τεχνικά στοιχεία συσκευής (τύπος, λειτουργικό σύστημα, έκδοση εφαρμογής).</li>
                <li>Ανώνυμα δεδομένα χρήσης για τη βελτίωση της εμπειρίας.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Χρήση Δεδομένων</h2>
              <p className="text-gray-700 mb-4">
                Τα δεδομένα που συλλέγονται χρησιμοποιούνται αποκλειστικά για:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Τη βελτίωση της εφαρμογής.</li>
                <li>Την επίλυση τεχνικών προβλημάτων.</li>
                <li>Την παροχή καλύτερης εμπειρίας χρήσης.</li>
              </ul>
              <p className="text-gray-700 mb-4">
                Δεν κοινοποιούμε προσωπικά δεδομένα σε τρίτους για εμπορικούς σκοπούς.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Ασφάλεια</h2>
              <p className="text-gray-700 mb-4">
                Λαμβάνουμε όλα τα απαραίτητα μέτρα για την προστασία των δεδομένων σας από μη εξουσιοδοτημένη πρόσβαση, αλλοίωση ή διαγραφή.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Δικαιώματα Χρηστών</h2>
              <p className="text-gray-700 mb-4">
                Έχετε το δικαίωμα να:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4">
                <li>Ζητήσετε πληροφορίες για τα δεδομένα που διατηρούμε.</li>
                <li>Ζητήσετε τη διόρθωση ή διαγραφή τους.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Τρίτες Υπηρεσίες</h2>
              <p className="text-gray-700 mb-4">
                Η εφαρμογή ενδέχεται να χρησιμοποιεί υπηρεσίες τρίτων (π.χ. Google, Apple) που έχουν τις δικές τους πολιτικές απορρήτου. Σας προτείνουμε να τις διαβάσετε.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Αλλαγές στην Πολιτική</h2>
              <p className="text-gray-700 mb-4">
                Η παρούσα Πολιτική Απορρήτου μπορεί να ενημερωθεί στο μέλλον. Οποιαδήποτε αλλαγή θα δημοσιεύεται μέσα στην εφαρμογή.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Επικοινωνία</h2>
              <p className="text-gray-700 mb-4">
                Για οποιαδήποτε ερώτηση σχετικά με την Πολιτική Απορρήτου, μπορείτε να επικοινωνήσετε μαζί μας στο:
              </p>
              <div className="bg-gray-100 p-4 rounded-lg">
                <p className="text-gray-700">
                  📧 <strong>valofocus@gmail.com</strong>
                </p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
